var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[(!_vm.liffUser)?_c('navigation'):_vm._e(),_c('div',[_c('openai-conversation-data-table')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }